import { getAbsoluteBaseURL } from '@nextUtils/getAbsoluteBaseURL';

const getExcludedGuideURLs = (baseUrl: string): string[] => [
  `${baseUrl}/blog/ozempic-prescriptions-uk`,
  `${baseUrl}/guides/lifestyle/weight-loss-programmes/juniper-vs-second-nature`,
  `${baseUrl}/guides/lifestyle/weight-loss-programmes/voy-vs-second-nature`,
  `${baseUrl}/guides/lifestyle/weight-loss-programmes/zoe-vs-second-nature`,
  `${baseUrl}/blog/best-weight-loss-injections-2023`,
  `${baseUrl}/guides/lifestyle/glp1s/boots-wegovy`,
  `${baseUrl}/guides/lifestyle/glp1s/wegovy-vs-mounjaro`,
  `${baseUrl}/blog/ozempic-nhs`,
  `${baseUrl}/blog/glp1-weight-loss-programme`,
  `${baseUrl}/guides/nutrition/nhs-trusted-meal-plan`,
  `${baseUrl}/guides/lifestyle/glp1s/how-quick-weight-loss-mounjaro`,
  `${baseUrl}/guides/lifestyle/glp1s/mounjaro-nhs`,
  `${baseUrl}/guides/lifestyle/weight-loss-programmes/noom-vs-second-nature`,
  `${baseUrl}/guides/lifestyle/weight-loss-programmes/numan-vs-second-nature`,
  `${baseUrl}/guides/glp1s/habitual-vs-second-nature`,
  `${baseUrl}/guides/lifestyle/glp1s/best-weight-loss-injections-2024`,
  `${baseUrl}/guides/lifestyle/glp1s/buy-mounjaro-online`,
  `${baseUrl}/guides/lifestyle/glp1s/buy-wegovy-online`,
  `${baseUrl}/guides/lifestyle/glp1s/mounjaro-cost-uk`,
  `${baseUrl}/guides/lifestyle/glp1s/tirzepatide-nhs`,
  `${baseUrl}/guides/lifestyle/glp1s/wegovy-nhs`,
];

export const shouldShowGuideModalBasedOnURL = (url: string): boolean => {
  const baseUrl = getAbsoluteBaseURL();
  const EXCLUDED_GUIDE_URLS = getExcludedGuideURLs(baseUrl);

  return !EXCLUDED_GUIDE_URLS.includes(url);
};

export const getGuideType = (url: string): 'medicated' | 'nonmedicated' => {
  if (url.includes('glp1s')) {
    return 'medicated';
  }
  return 'nonmedicated';
};
